"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterFormContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FilterFormContext = _react["default"].createContext({
  formId: null,
  filterType: null
});

exports.FilterFormContext = FilterFormContext;